import { useClient } from '../../../react-hooks/useClient';

const client = useClient();
export const loadBrandColors = async (websiteId) => {
    try {
        const colorPalette = await client.get(
            'grapes-editor/corporate-design/color-palette/' + websiteId,
            false,
            {
                cache: 'no-store',
            }
        );
        return colorPalette.map((item) => item.color);
    } catch (error) {
        console.error('Fehler beim Laden der Farben:', error);
        return [];
    }
};

export const loadMenusList = async (websiteId) => {
    try {
        return await client.get(
            'grapes-editor/corporate-design/menus/' + websiteId + '?_locale=de',
            false,
            {
                cache: 'no-store',
            }
        );
    } catch (error) {
        console.error('Fehler beim Laden der Farben:', error);
        return [];
    }
};

export const loadPagesList = async (websiteId) => {
    const conditions = {
        $and: [
            { $and: [] },
            {
                website: {
                    $eq: {
                        id: websiteId,
                        modelId: 'frontend/website',
                    },
                },
            },
        ],
    };

    const params = JSON.stringify(conditions);
    try {
        return await client.get('cms/content-page?' + params, false, {
            cache: 'no-store',
        });
    } catch (error) {
        console.error('Fehler', error);
        return [];
    }
};
